'use client';

import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
import { Button } from './ui/button';
import { Link } from '@/navigation';

export function PriceCard({ 
  plan, 
  highlighted, 
  icon: Icon, 
  btnLabel 
}: { 
  plan: any, 
  highlighted?: boolean, 
  icon: any, 
  btnLabel: string 
}) {
  return (
    <div className={`rounded-3xl p-10 flex flex-col transition-all duration-500 border ${highlighted ? 'bg-black text-white shadow-2xl scale-105 z-10 dark:bg-white dark:text-black border-transparent' : 'bg-white border-gray-100 hover:border-black dark:bg-zinc-900 dark:border-zinc-800 dark:hover:border-white'}`}>
      <div className="flex justify-between items-start mb-8">
        <div>
          <h4 className="font-mono text-xs font-bold tracking-[0.2em] opacity-60 uppercase mb-1">{plan.name}</h4>
          <p className="text-[10px] italic opacity-50">{plan.tagline}</p>
        </div>
        <Icon size={24} className={highlighted ? 'text-white dark:text-black' : 'text-gray-300'} />
      </div>
      <div className="flex items-baseline gap-2 mb-4">
        <span className="text-5xl font-bold tracking-tighter">{plan.price}</span>
        <span className="text-sm opacity-60">/ loyiha</span>
      </div>
      <p className="text-xs opacity-60 mb-8">{plan.duration}</p>
      <div className={`h-px mb-8 ${highlighted ? 'bg-white/10 dark:bg-black/10' : 'bg-gray-100 dark:bg-zinc-800'}`} />
      <ul className="space-y-4 mb-12 flex-1">
        {plan.features?.map((feature: any, i: number) => (
          <li key={i} className={`flex items-center gap-3 text-sm ${!feature.included ? 'opacity-40' : ''}`}>
            {feature.included ? (
              <Check size={16} className="text-green-500 shrink-0" />
            ) : (
              <X size={16} className="text-red-500 shrink-0" />
            )}
            <span>{feature.text}</span>
          </li>
        ))}
      </ul>
      <Button asChild className={`w-full rounded-full h-14 font-bold transition-transform hover:scale-[1.02] ${highlighted ? 'bg-white text-black hover:bg-gray-100 dark:bg-black dark:text-white' : 'bg-black text-white hover:bg-gray-800 dark:bg-white dark:text-black'}`}>
        <Link href="/pricing">
          {btnLabel}
        </Link>
      </Button>
    </div>
  );
}
